export enum EntityNames {
  TYPES = 'types',
  LANGUAGES = 'languages',
  SITES = 'sites',
  CONTENT_PIECES = 'content-pieces',
  TAGS = 'tags',
  VARIATIONS = 'variation-content-pieces'
}
